module.exports = __webpack_public_path__ + "static/media/51.9ae9e937.png";